import classNames from "classnames";

export interface ChipUIProps {
  theme?: "primary" | "secondary" | "tertiary" | "grey" | "purple";
  shadow?: boolean;
  variant?: "filled" | "outlined";
  boldText?: boolean;
}

interface ChipProps extends ChipUIProps {
  text: string;
  onClick?: () => void;
}

export const Chip = ({ text, theme = "primary", shadow = false, variant = "filled", boldText = false, onClick }: ChipProps) => {
  const getBgColor = () => {
    switch (theme) {
      case "secondary":
        return "bg-navy-blue";
      case "tertiary":
        return "bg-brand-green";
      case "purple":
        return "bg-brand-purple";
      case "grey":
        return "bg-brand-grey-light";
      case "primary":
      default:
        return "bg-white";
    }
  };

  const getBorderColor = () => {
    if (variant === "filled") return "border-transparent";

    switch (theme) {
      case "secondary":
        return "border-navy-blue";
      case "tertiary":
        return "border-brand-green";
      case "purple":
        return "border-brand-purple";
      case "grey":
      case "primary":
      default:
        return "border-brand-grey-light";
    }
  };

  const getTextColor = () => {
    switch (theme) {
      case "secondary":
      case "tertiary":
        return "text-white";
      case "purple":
        return "text-white";
      default:
        return "";
    }
  };

  return (
    <div
      role={onClick ? "button" : undefined}
      className={classNames(
        "rounded-full w-fit border py-1 px-3 text-center max-h-[34px] text-nowrap",
        getBgColor(),
        getBorderColor(),
        getTextColor(),
        { "font-bold": boldText },
        {
          "shadow-md": shadow,
        }
      )}
      onKeyDown={onClick}
      onClick={onClick}
    >
      {text}
    </div>
  );
};
